import { Box, Typography } from "@mui/material";
import {
  compactFormGridColumns,
  pageFormGridColumns,
  pageFormGridSx,
  pageFormLabelSx,
} from "../../constants/inAppNotificationConstant";

const FormFieldRow = ({
  label,
  required = false,
  hint,
  error,
  children,
  align = "start",
  compact = false,
  wide = false,
  page = false,
  stacked = false,
  responsiveStacked = false,
}) => (
  <Box
    sx={{
      display: stacked
        ? "flex"
        : responsiveStacked
          ? { xs: "flex", md: "grid" }
          : "grid",
      flexDirection: stacked || responsiveStacked ? "column" : undefined,
      gridTemplateColumns: stacked
        ? undefined
        : responsiveStacked
          ? { xs: "1fr", md: page ? pageFormGridColumns : compact ? compactFormGridColumns : { xs: "1fr", md: "minmax(140px, 200px) minmax(0, 1fr)" } }
          : page
            ? pageFormGridColumns
            : compact
              ? wide
                ? { xs: "1fr", md: "minmax(132px, 160px) minmax(0, 1fr)" }
                : compactFormGridColumns
              : { xs: "1fr", md: "minmax(140px, 200px) minmax(0, 1fr)" },
      alignItems: stacked
        ? "stretch"
        : responsiveStacked
          ? { xs: "stretch", md: page ? (align === "start" ? "start" : "center") : align }
          : page
            ? { xs: "stretch", md: align === "start" ? "start" : "center" }
            : align,
      gap: stacked || responsiveStacked
        ? 0.5
        : { xs: 0.75, md: page ? 1.25 : compact ? 1.25 : 2 },
      width: "100%",
      overflow: "visible",
    }}
  >
    <Box
      sx={{
        pt: stacked || responsiveStacked || page ? 0 : { md: align === "center" ? 0 : 0.5 },
        minWidth: 0,
        overflow: "visible",
      }}
    >
      <Typography
        variant="body2"
        sx={
          page || stacked
            ? pageFormLabelSx
            : { fontWeight: 600, color: "text.primary", lineHeight: 1.4, wordBreak: "break-word" }
        }
      >
        {label}
        {required && (
          <Typography component="span" color="error.main" sx={{ ml: 0.25 }}>
            *
          </Typography>
        )}
      </Typography>
      {hint && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 0.25, textAlign: "left" }}
        >
          {hint}
        </Typography>
      )}
    </Box>
    <Box sx={{ minWidth: 0, maxWidth: "100%", overflow: "visible", boxSizing: "border-box" }}>
      {children}
      {error && (
        <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
          {error}
        </Typography>
      )}
    </Box>
  </Box>
);

export const PageFormActionRow = ({ children }) => (
  <Box sx={pageFormGridSx}>
    <Box />
    <Box sx={{ minWidth: 0, display: "flex", justifyContent: "flex-end", pt: 0.5 }}>
      {children}
    </Box>
  </Box>
);

export default FormFieldRow;
